import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import { Provider as KitProvider } from "./context/KitContext";
import Home from "./Components/Home/Home";
import BuildKit from "./Components/BuildKit/BuildKit";
import BuildMyKit from "./Components/BuildMyKit/BuildMyKit";
import BuildMessage from "./Components/BuildMessage/BuildMessage";
import PreviewMessage from "./Components/PreviewMessage/PreviewMessage";
import BuildBackground from "./Components/BuildBackgorund/BuildBackground";
import BuildMyBackground from "./Components/BuildBackgorund/BuildMyBackground";
import ShowKit from "./Components/ShowKit/ShowKit";
import ShowVideo from "./Components/ShowKit/ShowVideo";
import ShowRainVideo from "./Components/ShowKit/ShowRainVideo";
import ShowImage from "./Components/ShowKit/ShowImage";
import ShowProfile from "./Components/ShowKit/ShowProfile";
import ShowWebtoon from "./Components/ShowKit/ShowWebtoon";
import ShowPreview from "./Components/ShowKit/ShowPreview";
import ShowMap from "./Components/ShowMap/ShowMap";

import "./App.css";
import "../node_modules/video-react/dist/video-react.css";

function App() {
  return (
    <div>
      <h1>CLOSED</h1>
    </div>
  );

  return (
    <KitProvider>
      <Router>
        <div className="App">
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route exact path="/build">
              <BuildMessage />
            </Route>
            <Route exact path="/preview">
              <PreviewMessage />
            </Route>
            <Route exact path="/background">
              <BuildBackground />
            </Route>
            <Route exact path="/my_background">
              <BuildMyBackground />
            </Route>
            <Route exact path="/show/:kitID">
              <ShowKit />
            </Route>
            <Route exact path="/show_video/:kitID">
              <ShowVideo />
            </Route>
            <Route exact path="/show_rain_video">
              <ShowRainVideo />
            </Route>
            <Route exact path="/show_image">
              <ShowImage />
            </Route>
            <Route exact path="/show_profile">
              <ShowProfile />
            </Route>
            <Route exact path="/show_webtoon">
              <ShowWebtoon />
            </Route>
            <Route exact path="/show_preview">
              <ShowPreview />
            </Route>
            <Route exact path="/show_map">
              <ShowMap />
            </Route>
            <Route exact path="/build_kit">
              <BuildKit />
            </Route>
            <Route exact path="/build_mykit">
              <BuildMyKit />
            </Route>
          </Switch>
        </div>
      </Router>
    </KitProvider>
  );
}

export default App;
